// test1097
(1097 && 0);
